module.exports = __webpack_public_path__ + "img/armhole length front.cf59af9d.png";